import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
	root: {
		background: 'linear-gradient(to right, #ffffff 0%, #fefefe 100%)',
	},
	wrapper: {
		minHeight: '100vh',
		paddingTop: '16px',
		paddingBottom: '16px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		[theme.breakpoints.up('md')]: {
			paddingTop: '10vh', // 140,
			paddingBottom: '5vh', // 64,
		},
	},
	logoBox: {
		'& svg': {
			color: '#333333',
		},
	},
	content: {
		display: 'grid',
		flexDirection: 'row',
		justifyContent: 'space-between',
		gridTemplateColumns: '100%',
		paddingBottom: '20px',
		[theme.breakpoints.up('md')]: {
			gridTemplateColumns: 'auto auto',
		},
	},
	lcol: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		order: 2,
		gap: '16px',
		paddingBottom: '40px',

		[theme.breakpoints.up('md')]: {
			order: 1,
			gap: 0,
			paddingBottom: 0,
		},
		'& .MuiTypography-root': {
			[theme.breakpoints.up('md')]: {
				whiteSpace: 'break-spaces',
			},
		},
	},
	h1: {
		fontWeight: 300,
		fontSize: '3.2rem',
		lineHeight: '110%',
		textAlign: 'center',
		[theme.breakpoints.up('md')]: {
			fontSize: '6.4rem',
			textAlign: 'left',
		},
	},
	description: {
		fontWeight: 400,
		fontSize: '1.6rem',
		lineHeight: '130%',
		[theme.breakpoints.up('md')]: {
			fontSize: '2rem',
		},
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		height: 155,
		width: '100%',
		[theme.breakpoints.up('md')]: {
			height: 96,
		},
	},
	label: {
		fontWeight: 400,
		fontSize: '1.6rem',
		lineHeight: '130%',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		position: 'relative',
		gap: '8px',
		[theme.breakpoints.up('md')]: {
			width: 580,
			flexDirection: 'row',
			gap: 0,
		},
	},
	formTextField: {
		borderRadius: '60px',
		'& .MuiInputBase-input': {
			padding: '14px 14px',
			paddingLeft: '32px',
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#E0E0E0',
			borderRadius: '60px',
		},
		'& .MuiFormHelperText-root': {
			position: 'absolute',
			bottom: '-84px',
			[theme.breakpoints.up('md')]: {
				bottom: '-30px',
			},
		},
		'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active': {
			transition: 'background-color 600000s 0s, color 600000s 0s',
		},
	},
	appFormSubmit: {
		fontWeight: 500,
		fontSize: '1.6rem',
		lineHeight: '130%',
		color: '#FFFFFF',

		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '15px 32px',
		gap: '10px',
		background: '#3889FA',
		borderRadius: '40px',

		textTransform: 'none',
		width: 'auto',

		[theme.breakpoints.up('md')]: {
			position: 'absolute',
			right: 0,
			top: 0,
		},
	},
	formLoader: { padding: '10.5px 0' },
	rcol: {
		[theme.breakpoints.down('md')]: {
			order: 1,
			paddingTop: '24px',
			paddingBottom: '40px',
			justifyContent: 'center',
			display: 'flex',
		},
		[theme.breakpoints.up('md')]: {
			order: 2,
		},
		[theme.breakpoints.up('lg')]: {
			paddingRight: '30px',
		},

		'& img': {
			[theme.breakpoints.down('md')]: {
				height: '200px',
			},
		},
	},
	footer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '16px',
		flexDirection: 'column',
		[theme.breakpoints.up('md')]: {
			flexDirection: 'row',
			gap: 0,
		},
	},
	linksContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		gap: '16px',

		'& .MuiListItem-root': {
			padding: 0,
			width: 'auto',
			'& svg': {
				color: '#333333',
				'& circle': {
					fill: '#F2F2F2',
				},
			},
		},
	},
	copyright: {
		fontWeight: 400,
		fontSize: '1.2rem',
		lineHeight: '15px',
		letterSpacing: '0.01em',
		textAlign: 'center',
		[theme.breakpoints.up('md')]: {
			textAlign: 'left',
		},
	},
}));
